/** ロールの上下関係。API 側(app/core/auth.py の ROLE_ORDER)と同じ並びにする。 */
import type { Me } from "./api";

const ORDER = ["viewer", "operator", "approver", "admin"];

/** suite:admin か、いずれかのアプリの admin。管理者操作ログの可視性に使う。 */
export function isAnyAdmin(me: Me | undefined): boolean {
  if (!me) return false;
  return me.is_suite_admin || me.roles.some((r) => r.endsWith(":admin"));
}

/** `required`(例 "hr:operator")以上を持っているか。suite:admin は全部通る。 */
export function hasRole(me: Me | undefined, required: string): boolean {
  if (!me) return false;
  if (me.is_suite_admin) return true;
  const [app, level] = required.split(":");
  const need = ORDER.indexOf(level);
  return me.roles.some((r) => {
    const [a, l] = r.split(":");
    return a === app && ORDER.indexOf(l) >= need && need >= 0;
  });
}

/**
 * `role` をそのまま持っているか(上下関係を見ない)。suite:admin は全部通る。
 * `reception:host` のように ORDER の外にあるロールに使う(API 側 has_role の host 扱いと同じ)。
 */
export function hasExactRole(me: Me | undefined, role: string): boolean {
  if (!me) return false;
  if (me.is_suite_admin) return true;
  return me.roles.includes(role);
}
